import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';

import Layout from '../components/Layouts/Layout';
import WinnersLayout from '../components/Layouts/WinnersLayout';
import YoutubeVideo from '../components/Video/YoutubeVideo';
import TextBlockWinner from '../components/TextBlock/TextBlockWinner';

import Metadata from '../components/Metadata/Metadata';

export const query = graphql`
  query($slug: String!) {
    winnersJson(slug: { eq: $slug }) {
      name
      company
      bio
      companyWebsite
      sector
      typeOfBusiness
      basedIn
      image
      youtubeVideoID
      description
      credit
    }
    allFile {
      edges {
        node {
          publicURL
          relativeDirectory
          name
        }
      }
    }
  }
`;

const WinnersTemplate = ({ data, location }) => {
  const winner = data.winnersJson;
  const winnerImages = data.allFile.edges;
  let currentWinnerPortraitImage = '';
  let currentWinnerOgImage = '';
  let currentWinnerGalleryImage = '';
  let currentWinnerGalleryImageMobile1 = '';
  let currentWinnerGalleryImageMobile2 = '';
  let currentWinnerGalleryImageMobile3 = '';

  // get current winner image from available images
  winnerImages.forEach((imageSet) => {
    if (imageSet.node.name === winner.image) {
      if (imageSet.node.relativeDirectory === 'og') {
        currentWinnerOgImage = imageSet.node.publicURL;
      } else if (imageSet.node.relativeDirectory === 'illustrations') {
        currentWinnerPortraitImage = imageSet.node.publicURL;
      }
    } else if (imageSet.node.name === `${winner.image}-Gallery`) {
      if (imageSet.node.relativeDirectory === 'gallery') {
        currentWinnerGalleryImage = imageSet.node.publicURL;
      }
    } else if (imageSet.node.name === `${winner.image}-Gallery-1`) {
      if (imageSet.node.relativeDirectory === 'gallery') {
        currentWinnerGalleryImageMobile1 = imageSet.node.publicURL;
      }
    } else if (imageSet.node.name === `${winner.image}-Gallery-2`) {
      if (imageSet.node.relativeDirectory === 'gallery') {
        currentWinnerGalleryImageMobile2 = imageSet.node.publicURL;
      }
    } else if (imageSet.node.name === `${winner.image}-Gallery-3`) {
      if (imageSet.node.relativeDirectory === 'gallery') {
        currentWinnerGalleryImageMobile3 = imageSet.node.publicURL;
      }
    }
  });

  return (
    <>
      <Metadata />
      <Layout
        round='2'
        customClass='application-header__left-trap--yellow application-header--small'
      >
        <div className='u-overflow-hidden--off'>
          <div className='uk-container'>
            <div className='uk-margin-large-bottom'>
              <YoutubeVideo
                youtubeID={winner.youtubeVideoID}
                caption='Videos recorded by winners following Covid-19 safety measures. Film-making by Naomi Joda.'
              />
            </div>
          </div>
        </div>
        <WinnersLayout>
          <div className='uk-container uk-margin-large-top'>
            <div className='uk-margin-large-top uk-margin-large-bottom'>
              <TextBlockWinner
                subheading={winner.company}
                heading={winner.name}
                content={winner.bio}
                website={winner.companyWebsite}
                sector={winner.sector}
                typeOfBusiness={winner.typeOfBusiness}
                basedIn={winner.basedIn}
                illustration={currentWinnerPortraitImage}
                gallery={currentWinnerGalleryImage}
                galleryMobile1={currentWinnerGalleryImageMobile1}
                galleryMobile2={currentWinnerGalleryImageMobile2}
                galleryMobile3={currentWinnerGalleryImageMobile3}
                credit={winner.credit}
              />
            </div>
          </div>
        </WinnersLayout>
      </Layout>
    </>
  );
};

WinnersTemplate.propTypes = {
  location: PropTypes.object.isRequired,
  data: PropTypes.PropTypes.shape({
    winnersJson: PropTypes.shape({
      name: PropTypes.string.isRequired,
      company: PropTypes.string.isRequired,
      bio: PropTypes.string.isRequired,
      companyWebsite: PropTypes.string.isRequired,
      sector: PropTypes.string.isRequired,
      typeOfBusiness: PropTypes.string.isRequired,
      basedIn: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      youtubeVideoID: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      credit: PropTypes.string.isRequired,
    }).isRequired,
    allFile: PropTypes.shape({
      edges: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
    }).isRequired,
  }).isRequired,
};

export default WinnersTemplate;
